import {ActionTree, MutationTree} from 'vuex'
import sdk from '@/lib/kepler/sdk'
import {Timestamps} from '@/lib/kepler/interfaces'
import moment from 'moment'
import {RootState} from '@/store'

export class TimestampsState {
  public remoteTimestamps: Timestamps | {[key: string]: string | number} = {}
  public localTimestamps: Timestamps | {[key: string]: string | number} = {}
}

const mutations: MutationTree<TimestampsState> = {
  TIMESTAMPS(stateT, payload: Timestamps) {
    stateT.remoteTimestamps = payload
  },
  SET_LOCAL_TIMESTAMP(stateT, payload: {[key: string]: string |number }) {
    Object.assign(stateT.localTimestamps, payload)
  },
  PURGE_TIMESTAMPS(stateT) {
    stateT.remoteTimestamps = {}
  },
}

const actions: ActionTree<TimestampsState, RootState> = {
  timestamps({state, commit, dispatch}) {
    return sdk.app.timestamps()
      .then((payload) => {
        commit('TIMESTAMPS', payload.data)
        // console.log('cron 1m, timestamps')
        const t = Object.keys(payload.data).filter((key) => !key.includes('_timestamp'))
        t.forEach((key) => {
          const localTimestamp = state.localTimestamps[key + '_timestamp']
          const remoteTimestamp = payload.data[key + '_timestamp']
          const updateAvailable = !localTimestamp || remoteTimestamp >= localTimestamp

          const formatLocalTimestamp = (k: string) => {
            const o: {[key: string]: string |number } = {}
            o[k + '_timestamp'] = moment().unix()
            o[k] = moment().format('YYYY-MM-DD hh:mm:ss')
            return o
          }

          const timestampMap: {[key: string]: string} = {
            client: 'getClient',
            driver: 'getDriver',
            drivers: 'getDrivers',
            reservation: 'reservationHistoryDefault',
            invoice: '',
            subscription: 'getSubscriptions',
            documents: 'getDocuments',
            payment_methods: 'getPaymentMethods',
            wallet_records: '',
            plans: 'getPlans',
            reports: 'getReports',
          }

          // Update Timestamp
          if (updateAvailable && timestampMap[key]) {
            dispatch(timestampMap[key]).then(() => {
                commit('SET_LOCAL_TIMESTAMP', formatLocalTimestamp(key))
                // console.log('updated ' + key)
              },
            )
          }

          if (key === 'reservation') {
            dispatch('current')
            dispatch('futureReservations')
          }
        })
        dispatch('sleep')
      }).catch((e) => e)
  },
  purge({commit}) {
    commit('PURGE_TIMESTAMPS')
  },
}

export default {
  state: new TimestampsState(),
  mutations,
  actions,
}
